import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * AIDisclaimerBanner — displays a disclaimer for AI-generated content.
 *
 * Placed at the top of modals that contain LLM-generated analysis
 * (strategy briefs, displacement reports, war room playbooks).
 */
function AIDisclaimerBanner({ compact = false }) {
  return (
    <div className={`vca-ai-disclaimer ${compact ? 'vca-ai-disclaimer--compact' : ''}`}>
      <AlertTriangle size={compact ? 14 : 16} />
      <span>
        AI-generated analysis based on procurement data.
        Validate competitive claims before customer conversations.
      </span>
    </div>
  );
}

export default AIDisclaimerBanner;
